import { render, staticRenderFns } from "./AttachmentsPanel.vue?vue&type=template&id=c80b46e6&scoped=true&"
import script from "./AttachmentsPanel.vue?vue&type=script&lang=js&"
export * from "./AttachmentsPanel.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsPanel.vue?vue&type=style&index=0&id=c80b46e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80b46e6",
  null
  
)

export default component.exports